<template>
  <section class="streamer">
    <!-- <iframe height=260 width=580 src='https://player.youku.com/embed/XNjY3MzE5OTA4'></iframe> -->
    <img src="~@/assets/streamer.jpg" />
  </section>
</template>
<script>
export default {};
</script>
<style scoped>
.streamer img{width: 100%;}
.streamer {overflow: hidden;height: 100%;margin-top: 12px;}

</style>